import { commitMutation, graphql } from 'react-relay';
import RelayService from "../service/RelayService";

const mutation = graphql`
  mutation SubmitSurveyMutation($input: SubmitSurveyInput!) {
    submitSurvey(input: $input) {
        clientMutationId
    }
  }
`;

function SubmitSurveyMutation(environment, args) {
  console.log("SubmitSurveyMutation.js args", args, RelayService.clientMutationId);
  return new Promise((resolve, reject) => {
    return commitMutation(environment, {
      mutation,
      variables: {
        input: {
          ...args,
          clientMutationId: RelayService.clientMutationId,
        }
      },
      updater: store => {
      },
      onCompleted: (data, errors) => {
        if (errors) {
          return reject(errors);
        }
        console.log("DownloadCatalogMutation.js onCompleted : ", data); // undefined
        return resolve(data);
      },
      optimisticUpdater: store => {
      }
    });
  })
}

export default SubmitSurveyMutation;
